import React from "react";
import { Link } from "react-router-dom";
import { footerData, contactInfo } from "../../data/mockData";
import { MapPin } from "lucide-react";

/* ─── Social Icons ─── */
const LinkedinIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
    <circle cx="4" cy="4" r="2"/>
  </svg>
);

const InstagramIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <circle cx="12" cy="12" r="4"/>
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
  </svg>
);

const FacebookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
  </svg>
);

const TwitterIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const RedditIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <circle cx="12" cy="12" r="10"/>
    <path fill="white" d="M20 12a2 2 0 00-2-2 2 2 0 00-1.3.5A9.6 9.6 0 0013 9.2l.5-2.5 2 .4a1.5 1.5 0 103-0.1 1.5 1.5 0 00-2.8-.5l-2.3-.5a.3.3 0 00-.4.2l-.6 3a9.7 9.7 0 00-3.8 1.3A2 2 0 004 12a2 2 0 001 1.7 3.5 3.5 0 000 .5c0 2.5 2.7 4.5 6 4.5s6-2 6-4.5a3.5 3.5 0 000-.5A2 2 0 0020 12zm-12 1a1 1 0 111 1 1 1 0 01-1-1zm5.5 2.7a3.3 3.3 0 01-2.5.8 3.3 3.3 0 01-2.5-.8.3.3 0 01.4-.4 2.7 2.7 0 002.1.6 2.7 2.7 0 002.1-.6.3.3 0 01.4.4zm-.5-1.7a1 1 0 111-1 1 1 0 01-1 1z"/>
  </svg>
);

const QuoraIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c1.53 0 2.98-.35 4.28-.96l1.58 1.96H21l-2.4-2.97C20.24 18.27 22 15.32 22 12c0-5.52-4.48-10-10-10zm3.64 14.39c-.5-.78-1.07-1.44-1.64-1.93-.42.1-.86.15-1.32.15-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.54-.7 2.92-1.8 3.85.48.44.96 1.01 1.4 1.73l-1.64 1.2z"/>
  </svg>
);

const socials = [
  {
    name: "LinkedIn",
    href: footerData.socials.linkedin,
    icon: LinkedinIcon,
    bg: "#0A66C2",
  },
  {
    name: "Instagram",
    href: footerData.socials.instagram,
    icon: InstagramIcon,
    bg: "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)",
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61587665759747",
    icon: FacebookIcon,
    bg: "#1877F2",
  },
  {
    name: "Twitter / X",
    href: "https://www.x.com/UrbanHunter_Ads",
    icon: TwitterIcon,
    bg: "#000000",
  },
  {
    name: "Reddit",
    href: "https://www.reddit.com/user/Opening-Bat-9599",
    icon: RedditIcon,
    bg: "#FF4500",
  },
  {
    name: "Quora",
    href: "https://www.quora.com/profile/urbanhunter",
    icon: QuoraIcon,
    bg: "#B92B27",
  },
];

const Footer = () => {
  return (
    <footer>
      {/* Contact Info Section */}
      <div className="bg-[#F0EDFF] py-16">
        <div className="max-w-[1320px] mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Phone Card */}
            <div className="bg-white rounded-2xl p-8 md:p-10">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-5" />
              <p className="text-[#555] text-[15px] mb-2" style={{ fontFamily: "'Poppins', sans-serif" }}>
                Talk to a growth expert
              </p>
              <a
                href={`tel:${contactInfo.phone.replace(/-/g, "")}`}
                className="text-[#1B1B3A] text-[28px] md:text-[32px] font-bold no-underline hover:text-[#F26522] transition-colors"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {contactInfo.phone}
              </a>
            </div>

            {/* Address Card */}
            <div className="bg-white rounded-2xl p-8 md:p-10">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-5">
                <MapPin size={28} className="text-[#34A853]" />
              </div>
              <p className="text-[#1B1B3A] text-[16px] leading-relaxed mb-2" style={{ fontFamily: "'Poppins', sans-serif" }}>
                {contactInfo.address}
              </p>
              <p className="text-[#1B1B3A] text-[16px] mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
                {contactInfo.email}
              </p>
              <a
                href={contactInfo.mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1B1B3A] text-[13px] font-bold uppercase tracking-wider no-underline border-b-2 border-[#1B1B3A] pb-1 hover:text-[#F26522] hover:border-[#F26522] transition-colors"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                View on Map
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Links */}
      <div className="bg-[#F0EDFF] pb-6">
        <div className="max-w-[1320px] mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 py-10">
            {/* Solutions */}
            <div>
              <h4 className="text-[#1B1B3A] text-[18px] font-bold mb-5" style={{ fontFamily: "'Poppins', sans-serif" }}>
                Solutions
              </h4>
              <ul className="list-none p-0 m-0 flex flex-col gap-3">
                {footerData.solutions.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.link}
                      className="text-[#555] text-[14px] no-underline hover:text-[#F26522] transition-colors"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Who we are */}
            <div>
              <h4 className="text-[#1B1B3A] text-[18px] font-bold mb-5" style={{ fontFamily: "'Poppins', sans-serif" }}>
                Who we are
              </h4>
              <ul className="list-none p-0 m-0 flex flex-col gap-3">
                {footerData.whoWeAre.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.link}
                      className="text-[#555] text-[14px] no-underline hover:text-[#F26522] transition-colors"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Get in touch */}
            <div>
              <h4 className="text-[#1B1B3A] text-[18px] font-bold mb-5" style={{ fontFamily: "'Poppins', sans-serif" }}>
                Get in touch
              </h4>
              <ul className="list-none p-0 m-0 flex flex-col gap-3">
                {footerData.getInTouch.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.link}
                      className="text-[#555] text-[14px] no-underline hover:text-[#F26522] transition-colors"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-300 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4 text-[13px] text-[#555]" style={{ fontFamily: "'Poppins', sans-serif" }}>
              <span>{footerData.copyright}</span>
              <span className="hover:text-[#F26522] cursor-pointer transition-colors">Terms & Conditions</span>
              <span className="hover:text-[#F26522] cursor-pointer transition-colors">Privacy Policy</span>
            </div>

            {/* Social Icons */}
            <div className="flex items-center gap-2">
              {socials.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={social.name}
                    className="w-9 h-9 rounded-lg flex items-center justify-center text-white hover:opacity-80 hover:scale-110 transition-all duration-200"
                    style={{ background: social.bg }}
                  >
                    <Icon />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
